import React, { useCallback, useEffect } from 'react'
import ReactGA from 'react-ga'
import { View, Linking } from 'react-native'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigation, useRoute } from '@react-navigation/native'

import { Txt, Button, Spinner } from '../../components'
import styles from './styles'
import { getTriumphPayUrl, generateTriumphPayToken } from '../../redux/paymentsConnect/paymentsConnectActions'
import MainContainer from '../../navigation/layouts/Main/MainContainer'
ReactGA.pageview('/main/payments-connect')

const PaymentsConnect = () => {
  const dispatch = useDispatch()
  const navigation = useNavigation()
  const route = useRoute()
  const { loading, triumphPayUrl } = useSelector(state => state.paymentsConnectReducer)

  const onLink = useCallback(() => {
    dispatch(getTriumphPayUrl())
  }, [dispatch])

  useEffect(() => {
    if (triumphPayUrl) {
      Linking.openURL(triumphPayUrl)
    }
  }, [triumphPayUrl])

  useEffect(() => {
    if (route.params) {
      const { code } = route.params
      if (code) {
        const callback = () => navigation.navigate('main', { screen: 'payments' })
        dispatch(generateTriumphPayToken(code, callback))
      }
    }
  }, [dispatch, route.params, navigation])

  return (
    <MainContainer title='Payments Connection'>
      <View style={styles.container}>
        {loading ? (
          <Spinner />
        ) : (
          <>
            <Txt
              text='Link your triumph pay account here!'
              identity='h4'
              style={styles.text}
            />
            <Txt
              text='We require your authorization to show the payments information/history'
              identity='body2'
              style={styles.text}
            />
            <Button
              title='Allow'
              onPress={onLink}
              containerStyle={styles.buttonContainer}
            />
          </>
        )}
      </View>
    </MainContainer>
  )
}

export default PaymentsConnect
